export const BillingControllerFactory = ({
  billingService,
}: {
  billingService: IBillingService;
}) => {
  /**
   * Payers
   */
  const getPayers: IGetBillingPayers = async (payload) => {
    const response = await billingService.getPayers(payload);
    return response;
  };

  const updatePayer: IUpdateBillingPayer = async (payload) => {
    const response = await billingService.updatePayer(payload);
    return response;
  };

  const createPayer: ICreateBillingPayer = async (payload) => {
    const response = await billingService.createPayer(payload);
    return response;
  };

  const deletePayer: IDeleteBillingPayer = async (id) => {
    const response = await billingService.deletePayer(id);
    return response;
  };

  /**
   * Providers
   */
  const getProviders: IGetBillingProviders = async (payload) => {
    const response = await billingService.getProviders(payload);
    return response;
  };

  const updateProvider: IUpdateBillingProvider = async (payload) => {
    const response = await billingService.updateProvider(payload);
    return response;
  };

  const createProvider: ICreateBillingProvider = async (payload) => {
    const response = await billingService.createProvider(payload);
    return response;
  };

  const deleteProvider: IDeleteBillingProvider = async (id) => {
    const response = await billingService.deleteProvider(id);
    return response;
  };

  /**
   * Entity
   */
  const getEntities: IGetBillingEntity = async (payload) => {
    const response = await billingService.getEntities(payload);
    return response;
  };

  const updateEntity: IUpdateBillingEntity = async (payload) => {
    const response = await billingService.updateEntity(payload);
    return response;
  };

  const createEntity: ICreateBillingEntity = async (payload) => {
    const response = await billingService.createEntity(payload);
    return response;
  };

  const deleteEntity: IDeleteBillingEntity = async (id) => {
    const response = await billingService.deleteEntity(id);
    return response;
  };

  /**
   * Rosters
   */
  const getRosters: IGetBillingRoster = async (payload) => {
    const response = await billingService.getRosters(payload);
    return response;
  };

  const updateRoster: IUpdateBillingRoster = async (payload) => {
    const response = await billingService.updateRoster(payload);
    return response;
  };

  const createRoster: ICreateBillingRoster = async (payload) => {
    const response = await billingService.createRoster(payload);
    return response;
  };

  const deleteRoster: IDeleteBillingRoster = async (id) => {
    const response = await billingService.deleteRoster(id);
    return response;
  };

  /**
   * Patients
   */
  const getPatients: IGetBillingPatients = async (payload) => {
    const response = await billingService.getPatients(payload);
    return response;
  };

  const updatePatient: IUpdateBillingPatient = async (payload) => {
    const response = await billingService.updatePatient(payload);
    return response;
  };

  const createPatient: ICreateBillingPatient = async (payload) => {
    const response = await billingService.createPatient(payload);
    return response;
  };

  const deletePatient: IDeleteBillingPatient = async (id) => {
    const response = await billingService.deletePatient(id);
    return response;
  };

  /**
   * Charges
   */
  const getCharges: IGetBillingCharges = async (payload) => {
    const response = await billingService.getCharges(payload);
    return response;
  };

  const updateCharges: IUpdateBillingCharges = async (payload) => {
    const response = await billingService.updateCharges(payload);
    return response;
  };

  const createCharges: ICreateBillingCharges = async (payload) => {
    const response = await billingService.createCharges(payload);
    return response;
  };

  const deleteCharges: IDeleteBillingCharges = async (id) => {
    const response = await billingService.deleteCharges(id);
    return response;
  };

  const getChargesStatusSummary = async (payload: any) => {
    const response = await billingService.getChargesStatusSummary(payload);
    return response;
  };

  return {
    getPayers,
    updatePayer,
    createPayer,
    deletePayer,

    getProviders,
    updateProvider,
    createProvider,
    deleteProvider,

    getEntities,
    updateEntity,
    createEntity,
    deleteEntity,

    getRosters,
    updateRoster,
    createRoster,
    deleteRoster,

    getPatients,
    updatePatient,
    createPatient,
    deletePatient,

    getCharges,
    updateCharges,
    createCharges,
    deleteCharges,
    getChargesStatusSummary,
  };
};
